import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import CarDetail from "../../../components/comment/carbookstatus/carDetail";
import CompletedTrip from "../../../components/comment/startendtrip/completedTrip";
const completedcontent = () => {
  return (
    <section className="completed-Booking pt-4 pb-10">
      <Container>
        {/* <Row>
          <Col md={9} className="verification-wrap pickup-content-wrap ">
            <div className="verification-wrap">
              <div className="row">
                <div className="col-md-7 pickup-content ">
                  <div className="row">
                    <div className="col-md-12">
                      <CompletedTrip />
                    </div>
                  </div>
                  <div className="row pickup-trip ">
                    <div className="col-md-6">
                      <span className="src-dest">TRIP PICKUP TIME</span>
                      <div className="trip-date">Sat, 25 Jun ’22, 08:30 AM</div>
                    </div>
                    <div className="col-md-6 d-flex align-items-end flex-column ">
                      <span className="src-dest">TRIP DROP OFF TIME</span>
                      <div className="trip-date">Sun, 26 Jun ’22, 04:30 PM</div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-12 complete-date">Completed on 26th jun, 5:00 PM</div>
                  </div>
                </div>

                <div className="col-md-5 px-0">
                  <div>
                    <CarDetail />
                  </div>
                </div>
              </div>
            </div>
          </Col>

          <Col md={3}>
            <div className="verification-wrap summary-wrap">
              <div className="complete-title all-one-title">
                Payment Summary
              </div>

              <div className="fare-detail-content ">
                <div className="fare">Total Cost</div>
                <div className="price">₹7,878 </div>
              </div>

              <div className="fare-detail-content ">
                <div className="fare">Processing refunds</div>
                <div className="price">₹5,000 </div>
              </div>

              <div className="fare-detail-content ">
                <div className="fare">You Paid</div>
                <div className="price">₹12,875 </div>
              </div>
              <div className="fare-detail-content pt-0  ">
                {" "}
                <p className="credit-card">credit card</p>
              </div>

              <div className="fare-detail-content balance">
                <div className="fare balance-fare ">Balance</div>
                <div className="price balance-fare">₹0 </div>
              </div>
            </div>
          </Col>
        </Row> */}

        <Row>
          <Col lg={9}>
            <div className="verification-wrap pickup-content-wrap">
              <div>
                <div className="row test-wrap">
                  <div className="col-md-7 test-pick-wrap">
                    <div className="pickup-content ">
                      <div className="row">
                        <div className="col-md-12">
                          <CompletedTrip />
                        </div>
                      </div>
                      <div className="row pickup-trip ">
                        <div className="col-md-6">
                          <div className="pickup-time">
                            <span className="src-dest">TRIP PICKUP TIME</span>
                            <div className="trip-date">
                              Sat, 25 Jun ’22, 08:30 AM
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6  ">
                          <div className="end-time">
                            <span className="src-dest">TRIP DROP OFF TIME</span>
                            <div className="trip-date">
                              Sun, 26 Jun ’22, 04:30 PM
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="row">
                        <div className="col-md-12 ">
                          <div className="complete-date">
                            Completed on 26th jun, 5:00 PM
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-md-5 p-0">
                    <div>
                      <CarDetail />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Col>

          <Col lg={3} className="summary-wrap">
            <div className="verification-wrap ">
              <div className="complete-title all-one-title">
                Payment Summary
              </div>

              <div className="fare-detail-content ">
                <div className="fare">Total Cost</div>
                <div className="price">₹7,878 </div>
              </div>

              <div className="fare-detail-content ">
                <div className="fare">Processing refunds</div>
                <div className="price">₹5,000 </div>
              </div>

              <div className="fare-detail-content ">
                <div className="fare">You Paid</div>
                <div className="price">₹12,875 </div>
              </div>
              <div className="fare-detail-content pt-0  ">
                {" "}
                <p className="credit-card">credit card</p>
              </div>

              <div className="fare-detail-content balance">
                <div className="fare balance-fare ">Balance</div>
                <div className="price balance-fare">₹0 </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default completedcontent;
